import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface OdooToast { id: number; ok: boolean; texto: string; }

/** Avisos breves (toast) de la pantalla de Odoo. Se cierran solos a los 4 s. */
@Injectable({ providedIn: 'root' })
export class OdooToastService {
  private seq = 0;
  private readonly _lista = new BehaviorSubject<OdooToast[]>([]);
  readonly lista$ = this._lista.asObservable();

  mostrar(texto: string, ok = true): void {
    const id = ++this.seq;
    this._lista.next([...this._lista.value, { id, ok, texto }].slice(-3));
    setTimeout(() => this.cerrar(id), 4000);
  }

  cerrar(id: number): void {
    this._lista.next(this._lista.value.filter((t) => t.id !== id));
  }
}
